// Session management utilities for guest users

export const generateSessionId = () => {
    return 'guest_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
};

export const getSessionId = () => {
    let sessionId = localStorage.getItem('gameSessionId');
    if (!sessionId) {
        sessionId = generateSessionId();
        localStorage.setItem('gameSessionId', sessionId);
    }
    return sessionId;
};

export const getGuestName = () => {
    return localStorage.getItem('guestName') || 'Guest';
};

export const setGuestName = (name) => {
    localStorage.setItem('guestName', name);
};
